import { useState } from "react";

import { Input, Box, Button, Heading, Label, Stack, Paragraph } from "@twilio-paste/core";
import WelcomeDialog from "./WelcomeDialog";


function PhoneNumberPickerContainer({ children }) {
  return <Box
    maxWidth={"75%"}
    margin={"auto"}
    marginY={"space120"}
    padding={"space120"}
    backgroundColor={"colorBackgroundBody"}
    boxShadow={"shadow"}
    borderRadius={"borderRadius20"}
  >
    {children}
  </Box>
}


function PhoneNumberPicker({ configureNumberInUse, phoneNumbers }) {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState("");

  const validatePhoneNumber = (number) => {
    // Basic validation for international phone numbers (E.164 format)
    const phoneRegex = /^\+?[1-9]\d{1,14}$/;
    return phoneRegex.test(number.replace(/[\s-()]/g, ''));
  };

  const handleSubmit = () => {
    const cleanedNumber = phoneNumber.replace(/[\s-()]/g, '');
    
    if (!validatePhoneNumber(cleanedNumber)) {
      setError("Please enter a valid phone number (e.g., +1234567890)");
      return;
    }

    setError("");
    configureNumberInUse({
      phoneNumber: cleanedNumber,
      friendlyName: "Manual Entry"
    });
  };

  return (
    <PhoneNumberPickerContainer>
      <WelcomeDialog />
      <Stack orientation="vertical" spacing="space60">
        <Heading as="h2" variant="heading20">Enter your phone number</Heading>
        <Paragraph>
          Enter the phone number you want to use with the Dev Phone. This phone number will be used to send messages and make calls.
          Use international format (e.g., +1234567890).
        </Paragraph>
        
        <Box>
          <Label htmlFor="phoneNumberInput" required>
            Phone number
          </Label>
          <Input
            id="phoneNumberInput"
            type="tel"
            placeholder="+1234567890"
            value={phoneNumber}
            onChange={(e) => {
              setPhoneNumber(e.target.value);
              setError("");
            }}
            hasError={!!error}
          />
          {error && (
            <Box marginTop="space30" color="colorTextError">
              {error}
            </Box>
          )}
        </Box>

        <Button 
          variant="primary" 
          onClick={handleSubmit}
          disabled={!phoneNumber.trim()}
        >
          Use this phone number
        </Button>
      </Stack>
    </PhoneNumberPickerContainer>
  );
}

export default PhoneNumberPicker;
